/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.toggleReadMore = this.toggleReadMore.bind(this);
  }
  connectedCallback() {
    this.readMoreButton = this.querySelector("[data-read-more-button]");
    this.readMoreWrapper = this.querySelector("[data-read-more-wrapper]");
    if (this.readMoreButton && this.readMoreWrapper) {
      this.readMoreButton.addEventListener('click', this.toggleReadMore);
    }
  }
  disconnectedCallback() {
    if (this.readMoreButton) {
      this.readMoreButton.removeEventListener('click', this.toggleReadMore);
    }
  }
  toggleReadMore() {
    const isExpanded = this.readMoreWrapper.classList.toggle('expanded');
    this.readMoreButton.textContent = isExpanded ? theme.readStrings.readLess : theme.readStrings.readMore;
  }
}
customElements.define('read-more', ReadMore);
/******/ })()
;